import { render, staticRenderFns } from "./MonitorDetailView.vue?vue&type=template&id=1712342a&scoped=true"
import script from "./MonitorDetailView.vue?vue&type=script&lang=js"
export * from "./MonitorDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1712342a",
  null
  
)

export default component.exports